import { render, staticRenderFns } from "./navigation-links.vue?vue&type=template&id=dc894f74&scoped=true"
import script from "./navigation-links.vue?vue&type=script&lang=js"
export * from "./navigation-links.vue?vue&type=script&lang=js"
import style0 from "./navigation-links.vue?vue&type=style&index=0&id=dc894f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc894f74",
  null
  
)

export default component.exports